import { compose } from 'redux';
import { GLOBAL } from 'saddlebag-browser';

import { stateSanitizer, actionSanitizer } from './sanitizer';

const $window = GLOBAL.getWindow();
const reduxDevtoolsExtensionOptions = {
  actionSanitizer,
  stateSanitizer,
};

export const composeEnhancers =
  // eslint-disable-next-line no-underscore-dangle
  ($window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    // eslint-disable-next-line no-underscore-dangle
    $window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(reduxDevtoolsExtensionOptions)) ||
  compose;
